import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { ADD_MEMBERS } from '../../Assets/images';
import { CommonSpaceHolderStyled } from './CommonSpaceHolderStyled';

const CommonSpaceHolder = (props) => (
  <CommonSpaceHolderStyled className={props?.outerCustomClass} animate={props?.animate}>
    <div className="card_wrapper">
      {props?.showIcon && <Image src={props?.icon} alt="placeholder" className="addmembers" />}
      {props?.title && <p className="title">{props?.title}</p>}
      {props?.subtitle && <p className="subtitle">{ReactHtmlParser(props?.subtitle)}</p>}
      {props?.children}
      {props?.info && (
        <div className="info">
          <div className="info_title">This may help!</div>
          <div className="info_note">Check the following to resolve the issue:</div>
          {props?.infoData.map((item) => (
            <div className="sentence" key={item.order}>
              <div>
                <div className="order">{item.order}</div>
              </div>
              <div className="text">{item.text}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  </CommonSpaceHolderStyled>
);

CommonSpaceHolder.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  showIcon: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.string,
  outerCustomClass: PropTypes.string,
  info: PropTypes.bool,
  infoData: PropTypes.object,
  animate: PropTypes.bool,
};

CommonSpaceHolder.defaultProps = {
  icon: ADD_MEMBERS,
  title: '',
  subtitle: '',
  children: '',
  outerCustomClass: '',
  showIcon: true,
  info:false,
  infoData: {},
  animate: false,
};
export default CommonSpaceHolder;
